import * as React from 'react';
const SvgHireflix = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="18" height="18" rx="4.5" fill="#5862FF" />
    <path
      d="M12.3406 4.01514L12.821 4.03052C14.3863 4.07992 15.6299 5.40447 15.6299 6.97153V11.2141C15.6299 12.6878 14.5306 13.9035 13.1074 14.0919C12.3016 12.6519 10.7645 11.6801 9 11.6799C7.23531 11.6801 5.69819 12.6517 4.89258 14.0919C3.46901 13.9033 2.37012 12.6876 2.37012 11.2141V6.97315C2.37012 5.40557 3.615 4.07969 5.18042 4.03125L5.7107 4.01514L9.05054 3.91113L12.3406 4.01514ZM9 6.16406C7.8489 6.16417 6.94579 7.06747 6.94531 8.21851C6.94531 9.37002 7.84869 10.2732 9 10.2734C10.1513 10.2732 11.0547 9.37002 11.0547 8.21851C11.0542 7.06767 10.1511 6.16435 9 6.16406Z"
      fill="white"
    />
    <circle cx="4.578" cy="5.893" r="0.874" fill="#F13D6D" />
  </svg>
);

export default SvgHireflix;
